import React from "react";
import white_3 from "../../assets/images/element_white_3.webp";
import white_4 from "../../assets/images/element_white_4.webp";
import customer_icon from "../../assets/images/customer-icon.webp";
import { Link } from "react-router-dom";

const Call = () => {
  const handleWhatsAppClick = () => {
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-667242866/rungCOCk-IUYEMnKwpAp",
      });
    }
  };

  return (
    <>
      <section className="cta_section new white_text" id="contact_sec">
        <div className="container">
          <div className="cta_box">
            <div className="element">
              <span className="element1">
                <img src={white_3} alt="image" />
              </span>
              <span className="element2">
                <img src={white_4} alt="image" />
              </span>
            </div>
            <div className="left">
              <div
                className="section_title"
                data-aos="fade-in"
                data-aos-duration={1500}
                data-aos-delay={100}
              >
                <img
                  src={customer_icon}
                  className="customer_icon"
                  alt="image"
                />

                <h3>Butuh Bantuan?</h3>

                <p>
                  Tim ahli kami siap melayani dan menjawab semua pertanyaan
                  Anda.
                </p>
              </div>
            </div>

            <div className="right">
              <div className="btn_block ">
                <a
                  href="https://api.whatsapp.com/send?phone=6282188883321&text=Hallo%20Mina%20Label!%20Saya%20Ingin%20Ingin%20bertanya%20tentang%20pembuatan%20logo%20woven."
                  className="btn puprple_btn aos-init aos-animate call_btn"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={handleWhatsAppClick}
                >
                  <i className="icofont-whatsapp" /> Hubungi Kami
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default Call;
